
<div class="white-bg no-padding no-margin">
  <!-- <breadcrumbs>
    <breadcrumb route="/" label="Dashboard"></breadcrumb>
    <breadcrumb [currentRoute]="true" label="Setup Training Types and Section"></breadcrumb>
  </breadcrumbs> -->


<mat-card>
  <div style="text-align: center; margin-top: 1%;">
    <span class="title-header">{{'Setup Training'  | translate | async}}</span>
  </div>

  <span style="font-size: larger; "><b>{{'Select Training Slides'  | translate | async}}</b></span>
    

    <mat-select placeholder="Select Training"   style="width: 345px;     margin-left: 6%;" [(ngModel)]="TrainingId">
      <mat-optgroup *ngFor="let group of TrainingCategories" [label]="group.Name">
        <mat-option *ngFor="let training of group.Trainings" [value]="training.TrainingId" (click)="TrainingSelect()">
          {{training.TrainingName  | translate | async}}
        </mat-option>
      </mat-optgroup>
    </mat-select>


    <ng-container *ngIf="TrainingId>0">
      <ng-container *ngFor="let fs of SubTrainings">
          <div style="display: flex;margin-left: 10%;    margin-top: 2%;" >
      
            <!-- <div style="float: right;cursor: pointer;" >
                              
              <i *ngIf="fs.Active" style="color: green;" class="material-icons sc-icon" (click)="toggleTrainingActive(f.TrainingId, false)">done</i>
         
              <i *ngIf="!fs.Active"style="color: red;" class="material-icons sc-icon" (click)="toggleCategoryActive(f.TrainingId, true)">cancel</i>
          
          </div> -->
            <span style="font-size: larger; "><b><u>{{fs.TrainigSubName  | translate | async}}</u></b></span>
            <i  class="material-icons sc-icon" style="align-self: center;cursor: pointer;"  (click)="OpenEditSubTraining(fs.TrainigSubId,false,fs.TrainigSubName)">edit</i>
              
      
              <!-- <ng-container > 
                <ng-container *ngIf="fs.Order == 0 && fs.TrainingCount >1">
                  <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_T(f.Order,f.TrainingTypeId)">arrow_drop_down</i> 
                </ng-container>
                    
                <ng-container *ngIf="fs.TrainingCount != 1 && fs.Order != 0">
                  <ng-container *ngIf="f.Order == fs.TrainingCount - 1">
                  <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_T(f.Order,f.TrainingTypeId)">arrow_drop_up</i> 
                  </ng-container>
              
                  <ng-container *ngIf="fs.Order != fs.TrainingCount - 1">
                    <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_T(f.Order,f.TrainingTypeId)">arrow_drop_down</i>
                    <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_T(f.Order,f.TrainingTypeId)">arrow_drop_up</i> 
                    </ng-container>
                </ng-container>

              </ng-container> -->
               
           </div>
        
           <ng-container *ngFor="let f of Slides">
            <ng-container *ngIf=" fs.TrainigSubId == f.SubSectionId">
              <div style="display: flex;margin-left: 15%; align-items: center" >
          
                <div style="float: right;cursor: pointer;" >
                                  
                  <i *ngIf="f.Active" style="color: green;" class="material-icons sc-icon" (click)="toggleSlideActive(f.SlideId, false)">done</i>
             
                  <i *ngIf="!f.Active"style="color: red;" class="material-icons sc-icon" (click)="toggleSlideActive(f.SlideId, true)">cancel</i>
              
              </div>
                <span style="font-size: larger; " class="slidename">{{f.SlideName  | translate | async}}</span>
                <!-- <i *ngIf="fs.QCategoryName!='Default Section'" class="material-icons sc-icon" style="align-self: center;"  (click)="OpenEditCategory(fc.FormId,fs.QuestionCatId,false,fs.QCategoryName)">edit</i> -->
                <i  class="material-icons sc-icon" style="align-self: center;cursor: pointer;"  (click)="OpenEditSlide(f.SlideId)">edit</i>

                <i  *ngIf="f.isLink==true" class="material-icons sc-icon" style="align-self: center;cursor: pointer;"  >videocam</i>
                <i  *ngIf="f.isLink==false" class="material-icons sc-icon" style="align-self: center;cursor: pointer;" >insert_photo</i>
          
                  <ng-container > 
                    <ng-container *ngIf="f.Order == 0 && fs.SlideCount >1">
                      <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_Slide(f.Order,f.SubSectionId)">arrow_drop_down</i> 
                    </ng-container>
                        
                    <ng-container *ngIf="fs.SlideCount != 1 && f.Order != 0">
                      <ng-container *ngIf="f.Order == fs.SlideCount - 1">
                      <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_Slide(f.Order,f.SubSectionId)">arrow_drop_up</i> 
                      </ng-container>
                  
                      <ng-container *ngIf="f.Order != fs.SlideCount - 1">
                        <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_Slide(f.Order,f.SubSectionId)">arrow_drop_down</i>
                        <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_Slide(f.Order,f.SubSectionId)">arrow_drop_up</i> 
                        </ng-container>
                    </ng-container>
                  
                   
                  </ng-container>
                 
          
                
              
                   
               </div>
            
               <div style="width: 100%;">
               
            </div>
             
            </ng-container>
            
          </ng-container>

           <div style="width: 100%;">
            <a class="button button--primary" style="margin-bottom: 16px;margin-left: 15%; " (click)="OpenAddSlide(fs.ParentTrainingId,fs.TrainigSubId)" >
              <span class="button__text">{{'Add Slide'  | translate | async}}</span></a>
        </div>
        
        
      </ng-container>
    </ng-container>
  <div style="margin-left: 10%;margin-top: 1%;" *ngIf="TrainingId>0" >
    <a class="button button--primary"   (click)="OpenAddSubTraining()" >
      <span class="button__text">{{'Add Section' | translate | async}}</span></a>
  </div>

  <div style="width: 100%;margin-top: 1%;display: flex; justify-content: flex-end;" *ngIf="TrainingId>0" >
    <a class="button button--primary" target="_blank"  href="setup-training-questions/{{TrainingId}}" >
      <span class="button__text">{{'Setup Questions'  | translate | async}} </span></a>
  </div>
</mat-card>
</div>